import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Spinner } from '@/components/app';
import { UserDetailsEditUserModal } from '@/components/userDetails';
import { UserDetailsFormDataUserEdit } from '@/common/viewModels/userDetails/form/data/UserDetailsFormDataUserEdit';
import { UserDetailsFormStateUserEdit } from '@/common/viewModels/userDetails/form/state/UserDetailsFormStateUserEdit';
import { UserDetail, TenantUserInvitation } from '@/common/models';
import { TenantUserInvitationStatus } from '@/common/viewModels/Enums';
import { distanceInWords } from 'date-fns';
import { UsersHelper } from '@/common/helpers/UsersHelper';
import {TelstraUIVueSvg, Button} from '@/external/telstra-ui-vue/components';

@Component({
  components: {
    Spinner,
    UserDetailsEditUserModal,
    TelstraUIVueSvg,
    Button,
  },
})
export default class UserDetailsHeader extends Vue {
  @Prop() userDetails!: UserDetail;
  @Prop() loading!: boolean;
  @Prop({ required: true }) tenantUserEditFormData!: UserDetailsFormDataUserEdit;
  @Prop({ required: true }) tenantUserEditFormState!: UserDetailsFormStateUserEdit;
  @Prop({ required: true }) tenantUserEditError!: string;
  @Prop() tenantUserInvitation!: TenantUserInvitation;
  @Prop({ required: true }) serverError!: string;

  get invitationExpiringIn() {
    return distanceInWords(new Date(this.tenantUserInvitation!.unixTimestampExpiringDate!), new Date());
  }

  get invitationStatusLabel() {
    return this.tenantUserInvitation && this.tenantUserInvitation!.status;
  }

  get invitationStatusVariant() {
    return this.invitationStatusLabel === TenantUserInvitationStatus.Expired ? 'error' : 'warning';
  }

  get invitationIsPending(): boolean {
    return !!(this.tenantUserInvitation && this.tenantUserInvitation!.status?.toLocaleLowerCase() === TenantUserInvitationStatus.Pending.toLocaleLowerCase());
  }

  get invitationIsExpired() {
    return !!(this.tenantUserInvitation && this.tenantUserInvitation!.expiringInDays === -1);
  }

  get showExpiryText(): boolean {
    return this.invitationIsPending && !this.invitationIsExpired;
  }

  get showReinvite(): boolean {
    return !!(this.tenantUserInvitation && this.tenantUserInvitation!.status?.toLocaleLowerCase() !== TenantUserInvitationStatus.Verified.toLocaleLowerCase());
  }

  @Emit()
  startModifyUser(): void {
    this.$emit('getUser');
  }

  @Emit()
  goBack(): void {
    this.$emit('goBack');
  }

  @Emit()
  onEditUserFormInputChange(fieldName: string, value: any): void {
    this.$emit('editUserFormInputChange', fieldName, value);
  }

  @Emit()
  onEditTenantUser(): void {
    this.$emit('editTenantUser');
  }

  getUserDisplayName(user: UserDetail): string {
    return UsersHelper.getUserDisplayName(user);
  }

  showEditUserModal(): void {
    (this.$refs.modalEditUser as UserDetailsEditUserModal).showModal();
  }

  hideEditUserModal(): void {
    (this.$refs.modalEditUser as UserDetailsEditUserModal).hideModal();
  }

  @Emit()
  sendInvitation() {
    this.$emit('sendInvitation');
  }

  private _resetState(): void {
    this.serverError = '';
  }
}
